import styled from 'styled-components';

/**
 * Props for ScrollWrapper
 */
interface ScrollWrapperProps extends React.HtmlHTMLAttributes<Element> {
  /** The maximum scroll height, over is overflow */
  maxHeight?: string;
  /** The maximum scroll height, over is overflow */
  maxWidth?: string;
}

/**
 * Wrapper for vertical scroll
 */
export const ScrollWrapper = styled.div<ScrollWrapperProps>`
  ${({ maxHeight }) =>
    maxHeight
      ? `
    max-height: ${maxHeight};
    overflow-y: scroll;
  `
      : ''};
  ${({ maxWidth }) =>
    maxWidth
      ? `
        max-width: ${maxWidth};
        overflow-x: scroll;
      `
      : 'overflow-x: hidden;'};
`;
